import { ProductType, UserType } from '@/@types';
import { UIComponent } from '@/components/core/components';
import { Trans } from '@lingui/react/macro';
import CarouselUser from '@/components/core/components/organism/carousel/user';
import * as styles from './users.styles';

const Users: UIComponent<{ product: ProductType; users: UserType[] }> = ({ product, users }) => {
  if (!users.length) {
    return null;
  }
  return (
    <div className={styles.root}>
      <h3 className={styles.title}>
        <Trans>Top influencers who recommended {product.name}</Trans>
      </h3>
      <CarouselUser users={users} />
    </div>
  );
};

export default Users;
